// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__212hd","title":"BackImages_title__1mdty","images":"BackImages_images__BL94g"};